(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bc-styled-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bc-styled-media')) {
    customElements.define('bc-styled-media', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const scene = this.querySelector('[data-media-scene]');
        const original = this.querySelector('[data-media-original]');
        const controls = this.querySelector('[data-media-switch]');
        const buttons = Array.from(this.querySelectorAll('[data-media-view]'));
        if (!scene || !original || !controls) return;
        const show = (view) => {
          scene.hidden = view !== 'styled';
          original.hidden = view === 'styled';
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mediaView === view)));
        };
        buttons.forEach(button => button.addEventListener('click', () => show(button.dataset.mediaView)));
        controls.hidden = false;
        show('styled');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
